import {FontAwesomeV6IconProps} from '@code-dot-org/component-library/fontAwesomeV6Icon';

export * from './fontAwesomeBrandIcons';

export const externalLinkIconProps: FontAwesomeV6IconProps = {
  iconName: 'up-right-from-square',
  iconStyle: 'solid',
};
